module.exports = __webpack_public_path__ + "img/not-checked-icon-white.701527ca.svg";